import React, { createRef } from 'react'
import PropTypes from 'prop-types'
import { Doughnut } from 'react-chartjs-2'

import { buildAllocationsDataProp } from './data'
import { buildAllocationsOptionsProp } from './options'

export const Allocations = ({ assetAllocationsDataset, hideLegend, semiCircle }) => {
  const dougnutInstance = createRef()

  const data = buildAllocationsDataProp(assetAllocationsDataset)
  const options = buildAllocationsOptionsProp(assetAllocationsDataset, hideLegend, semiCircle)

  return (
    <Doughnut
      ref={dougnutInstance}
      data={data}
      options={options}
    />
  )
}

Allocations.propTypes = {
  assetAllocationsDataset: PropTypes.arrayOf(PropTypes.object).isRequired,
  hideLegend: PropTypes.bool,
  semiCircle: PropTypes.bool
}
